module.exports = __webpack_public_path__ + "img/7.5d386cb2.svg";